import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import Button from './Button';
import theme, { buttonReset } from '../../styles/theme';
import { defaultProps, propTypes } from './common';

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
    };
  }

  handleOnSelectChange = (e, item) => {
    const { onChange } = this.props;
    e.preventDefault();
    onChange(item);
    this.handleOpenCloseDropdown();
  };

  handleOpenCloseDropdown = () => {
    const { hidden } = this.state;
    this.setState({
      hidden: !hidden,
    });
  };

  renderButton = (selected, classes) => {
    const { defaultText, error } = this.props;
    const selectedText = (selected && selected.label) || defaultText;

    return (
      <Button
        selected
        className={cn(classes.button, { error })}
        onClick={this.handleOpenCloseDropdown}
        buttonType="button"
      >
        {selectedText}
        <span className={classes.iconWrapper}>
          <svg className={classes.icon} viewBox="0 0 8 8">
            <path fill="currentColor" d="M4 6.67l-4-4 1.33-1.34L4 4l2.67-2.67L8 2.67l-4 4z" />
          </svg>
        </span>
      </Button>
    );
  };

  renderDropDown = (selected, classes) => {
    const { options } = this.props;
    return (
      <ul className={classes.dropdownOptions}>
        {options.map(item => (
          <li key={item.key} className={classes.dropdownStateItem}>
            <button
              type="button"
              className={cn(classes.dropdownButton, { active: selected === item.key })}
              onClick={e => this.handleOnSelectChange(e, item)}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { hidden } = this.state;
    const {
      classes, className, selected,
    } = this.props;

    return (
      <div className={cn(className, classes.container)}>
        {!hidden && (
          <div
            className={classes.dropDownClose}
            onClick={this.handleOpenCloseDropdown}
            role="presentation"
          />
        )}
        {this.renderButton(selected, classes)}
        {!hidden && this.renderDropDown(selected, classes)}
      </div>
    );
  }
}

DropDown.propTypes = {
  ...propTypes,
  onChange: PropTypes.func.isRequired,
  buttonTheme: PropTypes.shape({
    color: PropTypes.string.isRequired,
    selected: PropTypes.object.isRequired,
  }),
  defaultText: PropTypes.string.isRequired,
};
DropDown.defaultProps = { ...defaultProps };

export default injectSheet({
  container: {
    marginLeft: -8,
    marginRight: -8,
    position: 'relative',
    width: 'auto',
    maxWidth: 300,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100% + 16px)',
      width: 'calc(100% + 16px)',
    },
    padding: '0 8px',
    marginBottom: 8,
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  dropdownOptions: {
    position: 'absolute',
    top: 'calc(100% - 3px)',
    margin: '0 8px',
    left: 0,
    right: 0,
    listStyle: 'none',
    padding: 0,
    border: `1px solid ${theme.colors.borderDropdown}`,
    borderRadius: '2px',
    zIndex: 99998,
    backgroundColor: theme.colors.white,
    maxHeight: 500,
    overflow: 'hidden',
  },
  dropdownStateItem: {
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    margin: '0 !important',
    borderBottom: `1px solid ${theme.colors.borderDropdown}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  dropdownButton: {
    ...buttonReset({
      padding: [20, 16],
      whiteSpace: 'no-wrap',
      color: theme.colors.darkGrey,
      display: 'block',
      margin: 0,
      cursor: 'pointer',
      backgroundColor: theme.colors.white,
      width: '100%',
      textAlign: 'left',
      transition: 'color 300ms',
      outline: 0,
      fontSize: 12,
      fontFamily: `${theme.fonts.body} !important`,
      letterSpacing: 0.3,
      lineHeight: '16px',
      '&:hover, &:focus, &:active, &.active': {
        color: theme.colors.darkGrey,
        backgroundColor: theme.colors.blue50,
      },
    }),
  },
  dropDownClose: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 99997,
  },
  iconWrapper: {
    display: 'inline-block',
    position: 'absolute',
    top: 'calc(50% - 4px)',
    right: 16,
    pointerEvents: 'none',
  },
  button: {
    ...buttonReset({
      outline: 0,
      padding: [12, 18],
      fontFamily: `${theme.fonts.body} !important`,
      color: theme.colors.darkGrey,
      letterSpacing: 2,
      lineHeight: 'normal',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      border: `1px solid ${theme.colors.borderDropdown}`,
      '&::after': {
        borderBottomWidth: 2,
      },
      '&:hover,&:focus': {
        color: theme.colors.darkGrey,
        border: `1px solid ${theme.colors.secondary}`,
      },
      '&.error': {
        color: `${theme.colors.brandError} !important`,
        border: `1px solid ${theme.colors.brandError} !important`,
      },
    }),
  },
  icon: {
    display: 'block',
    width: 8,
    height: 8,
  },
})(DropDown);
